import {
  object as yupObject,
  string as yupString,
  bool as yupBool,
  date as yupDate,
} from 'yup';
import { ADD_EMPLOYEE_FORM_TRANSLATIONS } from 'const/translations';

export const validationSchema = () =>
  yupObject().shape({
    degreeEmployee: yupString().required('Field cannot be empty'),
    beforeEmployment: yupString(),
    hasCompanyInsurance: yupBool(),
    hasAnotherJob: yupBool(),
    since: yupDate()
      .nullable()
      .test({
        name: 'since-required',
        message: 'Field cannot be empty',
        test: function (value) {
          const { beforeEmployment } = this.parent;
          if (beforeEmployment && beforeEmployment.trim().length > 0) {
            return value !== null && value !== undefined;
          }
          return true;
        },
      }),
    beforeEmploymentDetails: yupString()
      .nullable()
      .test({
        name: 'beforeEmploymentDetails-required',
        message: 'Field cannot be empty',
        test: function (value) {
          const { beforeEmployment } = this.parent;
          if (
            beforeEmployment ===
            ADD_EMPLOYEE_FORM_TRANSLATIONS.GENERAL_LABELS.OTHER
          ) {
            return (
              value !== null && value !== undefined && value.trim().length > 0
            );
          }
          return true;
        },
      }),
  });
